import { HttpInterceptorFn } from '@angular/common/http'
import { from, switchMap } from 'rxjs'
import { fetchAuthSession } from 'aws-amplify/auth'

/**
 * authInterceptor — attaches a Cognito ID token to every outgoing HTTP request.
 *
 * Registered globally in app.config.ts via provideHttpClient(withInterceptors([...])).
 * Amplify's fetchAuthSession() automatically refreshes the token when it is
 * close to expiry, so the interceptor always provides a valid JWT.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  return from(fetchAuthSession()).pipe(
    switchMap(session => {
      const idToken = session.tokens?.idToken?.toString()
      if (!idToken) {
        return next(req)
      }
      const authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${idToken}` },
      })
      return next(authReq)
    }),
  )
}
